import { render } from "./DropDownListFornecedor.vue?vue&type=template&id=3898078e&ts=true"
import script from "./DropDownListFornecedor.vue?vue&type=script&lang=ts"
export * from "./DropDownListFornecedor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__